import BaseApiManager from '../baseApiManager';
import { showError } from '../../../redux/reducers/alerts/actions';
import { store } from '../../../redux/store';

export default class UserApi extends BaseApiManager {
  static async getInstance() {
    if (!UserApi.instance) {
      UserApi.instance = new UserApi();
      UserApi._initPromise = UserApi.instance.init();
    }
    await UserApi._initPromise;
    return UserApi.instance;
  }

  async fetchUser(attempt = 0) {
    try {
      const res = await this.get('current/user');

      if (this.isSuccess(res.status)) {
        return res.data;
      } else {
        store.dispatch(showError(true, `Server error when try to get user. Status:${res.status}`));
      }
    } catch (error) {
      return this.errorHandler(this.fetchUser.bind(this), error, attempt);
    }
  }

  async fetchSubscriptions(attempt = 0) {
    try {
      const res = await this.get(`user/${this.userId}/subscriptions`);

      if (this.isSuccess(res.status)) {
        return res.data;
      } else {
        store.dispatch(showError(true, `Server error when fetching subscriptions. Status:${res.status}`));
      }
    } catch (error) {
      return this.errorHandler(this.fetchSubscriptions.bind(this), error, attempt);
    }
  }

  async updateUserLocale(locale, attempt = 0) {
    try {
      const res = await this.patch(`user/${this.userId}/user`, { locale, });

      if (!this.isSuccess(res.status)) {
        store.dispatch(showError(true, `Server error when try to get user. Status:${res.status}`));
      }
    } catch (error) {
      return this.errorHandler(this.updateUserLocale.bind(this), error, locale, attempt);
    }
  }

  async sendContactMessage(payload, attempt = 0) {
    try {
      const res = await this.post('get-in-touch', payload);

      if (this.isSuccess(res.status)) {
        return res.data;
      } else {
        store.dispatch(showError(true, `Failed to send message. Status:${res.status}`));
      }
    } catch (error) {
      return this.errorHandler(this.sendContactMessage.bind(this), error, payload, attempt);
    }
  }
}
